import { baseApi } from "./baseApi";
import { API_ENDPOINTS } from "../../config/url";

// Types for common API
export interface UploadFileRequest {
  file: File;
}

export interface UploadFileResponse {
  data?: {
    url?: string;
    fileUrl?: string;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  [key: string]: any;
}

// Types for Flavour API
export interface FlavourItem {
  _id?: string;
  id?: string;
  name: string;
  color?: string;
  colourCode?: string;
  isActive?: boolean;
  status?: boolean;
  createdAt?: string;
  __v?: number;
  [key: string]: any;
}

export interface GetFlavourListRequest {
  page?: number;
  limit?: number;
  yogurtId?: string;
}

export interface GetFlavourListResponse {
  data?: {
    flavour?: FlavourItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteFlavourRequest {
  id: string;
}

export interface DeleteFlavourResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateFlavourStatusRequest {
  id: string;
  isActive: boolean;
}

export interface UpdateFlavourStatusResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface CreateFlavourRequest {
  name: string;
  colourCode: string;
}

export interface CreateFlavourResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateFlavourRequest {
  id: string;
  name: string;
  isActive: boolean;
  colourCode: string;
}

export interface UpdateFlavourResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Box Art API
export interface BoxArtItem {
  _id?: string;
  id?: string;
  name?: string;
  image?: string;
  imageUrl?: string;
  createdDate?: string;
  createdAt?: string;
  status?: boolean;
  isActive?: boolean;
  [key: string]: any;
}

export interface GetBoxArtListRequest {
  page?: number;
  limit?: number;
}

export interface GetBoxArtListResponse {
  data?: {
    boxArt?: BoxArtItem[];
    boxarts?: BoxArtItem[];
    box?: BoxArtItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteBoxArtRequest {
  id: string;
}

export interface DeleteBoxArtResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Topping API
export interface ToppingItem {
  _id?: string;
  id?: string;
  name?: string;
  image?: string;
  sliceImage?: string;
  quantityPerPiece?: number;
  maxLimit?: number;
  isActive?: boolean;
  restricted?: boolean;
  createdAt?: string;
  __v?: number;
  [key: string]: any;
}

export interface GetToppingListRequest {
  page?: number;
  limit?: number;
  yogurtId?: string;
}

export interface GetToppingListResponse {
  data?: {
    topping?: ToppingItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteToppingRequest {
  id: string;
}

export interface DeleteToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface SliceImage {
  image: string;
  multiplier: string;
  // Add any other properties that your slice images might have
}

export interface CreateToppingRequest {
  name: string;
  image: string;
  sliceImage: SliceImage[];
  quantityPerPiece: number;
  maxLimit: number;
}

export interface CreateToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateToppingStatusRequest {
  id: string;
  isActive?: boolean;
  restricted?: boolean;
}

export interface UpdateToppingStatusResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateToppingRequest {
  id: string;
  name: string;
  image: string;
  sliceImage: SliceImage[];
  quantityPerPiece: number;
  maxLimit: number;
}

export interface UpdateToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Greek Box API
export interface GreekBoxItem {
  _id?: string;
  id?: string;
  name?: string;
  image?: string;
  price?: number;
  flavorMinCount?: number;
  flavorMaxCount?: number;
  toppingMinCount?: number;
  toppingMaxCount?: number;
  isActive?: boolean;
  createdAt?: string;
  boxDetails?: {
    _id?: string;
    name?: string;
    image?: string;
    [key: string]: any;
  };
  flavourDetails?: {
    _id?: string;
    name?: string;
    [key: string]: any;
  };
  toppingDetails?: {
    _id?: string;
    name?: string;
    image?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface GetGreekBoxListRequest {
  page?: number;
  limit?: number;
  search?: string;
}

export interface GetGreekBoxListResponse {
  data?: {
    greekbox?: GreekBoxItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteGreekBoxRequest {
  id: string;
}

export interface DeleteGreekBoxResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface CreateGreekBoxRequest {
  name: string;
  image: string;
  sliceImage: string;
  price: number;
  description: string;
  boxIds: string[]; // Array of box art IDs
  flavorIds: string[]; // Array of flavor IDs
  flavorMinCount: number;
  flavorMaxCount: number;
  toppingIds: string[]; // Array of topping IDs
  toppingMinCount: number;
  toppingMaxCount: number;
}

export interface CreateGreekBoxResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateGreekBoxRequest {
  id: string;
  name?: string;
  image?: string;
  sliceImage?: string;
  price?: number;
  description?: string;
  boxIds?: string[]; // Array of box art IDs
  flavorIds?: string[]; // Array of flavor IDs
  flavorMinCount?: number;
  flavorMaxCount?: number;
  toppingIds?: string[]; // Array of topping IDs
  toppingMinCount?: number;
  toppingMaxCount?: number;
  isActive?: boolean;
  featured?: boolean;
}

export interface UpdateGreekBoxResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Yogurt Type API
export interface YogurtTypeItem {
  _id?: string;
  id?: string;
  name: string;
  pricing?: number;
  pricingMethod?: number; // Keep for backward compatibility
  isActive?: boolean;
  status?: boolean;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  [key: string]: any;
}

export interface GetYogurtTypeListRequest {
  page?: number;
  limit?: number;
  search?: string;
}

export interface GetYogurtTypeListResponse {
  data?: {
    yogurt?: YogurtTypeItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteYogurtTypeRequest {
  id: string;
}

export interface DeleteYogurtTypeResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface CreateYogurtTypeRequest {
  name: string;
  pricing: number; // API expects 'pricing' not 'pricingMethod'
}

export interface CreateYogurtTypeResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateYogurtTypeRequest {
  id: string;
  name?: string;
  pricing?: number; // API expects 'pricing' not 'pricingMethod'
  isActive?: boolean;
}

export interface UpdateYogurtTypeResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateYogurtTypeStatusRequest {
  id: string;
  isActive: boolean;
}

export interface UpdateYogurtTypeStatusResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Yogurt Flavor API
export interface YogurtFlavorItem {
  _id?: string;
  id?: string;
  image?: string;
  pricePer100g?: number;
  smallSize?: number;
  mediumSize?: number;
  largeSize?: number;
  isActive?: boolean;
  featured?: boolean;
  createdAt?: string;
  flavourDetails?: {
    _id?: string;
    name?: string;
  };
  [key: string]: any;
}

export interface GetYogurtFlavorListRequest {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
}

export interface GetYogurtFlavorListResponse {
  data?: {
    yogurtFlavors?: YogurtFlavorItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface DeleteYogurtFlavorRequest {
  id: string;
}

export interface DeleteYogurtFlavorResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface CreateYogurtFlavorRequest {
  image: string;
  yogurtId: string;
  flavorId: string;
  pricePer100g: number;
  smallSize: number;
  mediumSize: number;
  largeSize: number;
}

export interface CreateYogurtFlavorResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateYogurtFlavorRequest {
  id: string;
  image?: string;
  yogurtId?: string;
  flavorId?: string;
  pricePer100g?: number;
  smallSize?: number;
  mediumSize?: number;
  largeSize?: number;
  isActive?: boolean;
  featured?: boolean;
}

export interface UpdateYogurtFlavorResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

// Types for Yogurt Topping API
export interface YogurtToppingItem {
  _id?: string;
  id?: string;
  toppingId?: string;
  pricing?: number;
  price?: number; // Keep for backward compatibility
  isActive?: boolean;
  createdAt?: string;
  toppingDetails?: {
    _id?: string;
    name?: string;
    image?: string;
  };
  [key: string]: any;
}

export interface GetYogurtToppingListRequest {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
}

export interface GetYogurtToppingListResponse {
  data?: {
    yogurtToppings?: YogurtToppingItem[];
    total?: number;
    [key: string]: any;
  };
  message?: string;
  success?: boolean;
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

export interface CreateYogurtToppingRequest {
  yogurtId: string;
  toppingId: string;
  pricing: number;
}

export interface CreateYogurtToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface DeleteYogurtToppingRequest {
  id: string;
}

export interface DeleteYogurtToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateYogurtToppingRequest {
  id: string;
  yogurtId?: string;
  toppingId?: string;
  pricing?: number;
  isActive?: boolean;
}

export interface UpdateYogurtToppingResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface CreateBoxArtRequest {
  name: string;
  image: string;
}

export interface CreateBoxArtResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateBoxArtRequest {
  id: string;
  name: string;
  image: string;
}

export interface UpdateBoxArtResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export interface UpdateBoxArtStatusRequest {
  id: string;
  isActive: boolean;
}

export interface UpdateBoxArtStatusResponse {
  message?: string;
  success?: boolean;
  data?: any;
  [key: string]: any;
}

export const commonAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST - Upload File
    uploadFile: builder.mutation<UploadFileResponse, UploadFileRequest>({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: API_ENDPOINTS.COMMON.UPLOAD_FILE,
          method: "POST",
          body: formData,
          // Don't set Content-Type header - browser will set it automatically with boundary
        };
      },
      invalidatesTags: [],
    }),

    // GET - Get Flavour List
    getFlavourList: builder.query<
      GetFlavourListResponse,
      GetFlavourListRequest
    >({
      query: ({ page = 1, limit = 10, yogurtId }) => {
        const params: any = {
          page,
          limit,
        };
        
        // Include yogurtId in query params if provided
        if (yogurtId && typeof yogurtId === 'string' && yogurtId.trim() !== "") {
          params.yogurtId = yogurtId;
        }
        
        return {
          url: API_ENDPOINTS.FLAVOUR.LIST,
          method: "GET",
          params,
          headers: {
            "Content-Type": "application/json",
            "x-portal": "user",
          },
        };
      },
      providesTags: ["Flavour"],
    }),

    // POST - Create Flavour
    createFlavour: builder.mutation<
      CreateFlavourResponse,
      CreateFlavourRequest
    >({
      query: ({ name, colourCode }) => ({
        url: API_ENDPOINTS.FLAVOUR.CREATE,
        method: "POST",
        body: {
          name,
          colourCode,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Flavour"],
    }),

    // PUT - Update Flavour Status
    updateFlavourStatus: builder.mutation<
      UpdateFlavourStatusResponse,
      UpdateFlavourStatusRequest
    >({
      query: ({ id, isActive }) => ({
        url: API_ENDPOINTS.FLAVOUR.UPDATE(id),
        method: "PUT",
        body: {
          isActive,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Flavour"],
    }),

    // PUT - Update Flavour (Full Update)
    updateFlavour: builder.mutation<
      UpdateFlavourResponse,
      UpdateFlavourRequest
    >({
      query: ({ id, name, isActive, colourCode }) => ({
        url: API_ENDPOINTS.FLAVOUR.UPDATE(id),
        method: "PUT",
        body: {
          name,
          isActive,
          colourCode,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Flavour"],
    }),

    // DELETE - Delete Flavour
    deleteFlavour: builder.mutation<
      DeleteFlavourResponse,
      DeleteFlavourRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.FLAVOUR.DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Flavour"],
    }),

    // GET - Get Box Art List
    getBoxArtList: builder.query<GetBoxArtListResponse, GetBoxArtListRequest>({
      query: ({ page = 1, limit = 10 }) => ({
        url: API_ENDPOINTS.BOX_ART.LIST,
        method: "GET",
        params: {
          page,
          limit,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      providesTags: ["BoxArt"],
    }),

    // POST - Create Box Art
    createBoxArt: builder.mutation<CreateBoxArtResponse, CreateBoxArtRequest>({
      query: ({ name, image }) => ({
        url: API_ENDPOINTS.BOX_ART.CREATE,
        method: "POST",
        body: {
          name,
          image,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["BoxArt"],
    }),

    // PUT - Update Box Art
    updateBoxArt: builder.mutation<UpdateBoxArtResponse, UpdateBoxArtRequest>({
      query: ({ id, name, image }) => ({
        url: API_ENDPOINTS.BOX_ART.UPDATE(id),
        method: "PUT",
        body: {
          name,
          image,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["BoxArt"],
    }),

    // PUT - Update Box Art Status
    updateBoxArtStatus: builder.mutation<
      UpdateBoxArtStatusResponse,
      UpdateBoxArtStatusRequest
    >({
      query: ({ id, isActive }) => ({
        url: API_ENDPOINTS.BOX_ART.UPDATE(id),
        method: "PUT",
        body: {
          isActive,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["BoxArt"],
    }),

    // DELETE - Delete Box Art
    deleteBoxArt: builder.mutation<DeleteBoxArtResponse, DeleteBoxArtRequest>({
      query: ({ id }) => ({
        url: API_ENDPOINTS.BOX_ART.DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["BoxArt"],
    }),

    // GET - Get Topping List
    getToppingList: builder.query<
      GetToppingListResponse,
      GetToppingListRequest
    >({
      query: ({ page = 1, limit = 10, yogurtId }) => {
        const params: any = {
          page,
          limit,
        };
        
        // Include yogurtId in query params if provided
        if (yogurtId && typeof yogurtId === 'string' && yogurtId.trim() !== "") {
          params.yogurtId = yogurtId;
        }
        
        return {
          url: API_ENDPOINTS.TOPPING.LIST,
          method: "GET",
          params,
          headers: {
            "Content-Type": "application/json",
            "x-portal": "user",
          },
        };
      },
      providesTags: ["Topping"],
    }),

    // POST - Create Topping
    createTopping: builder.mutation<
      CreateToppingResponse,
      CreateToppingRequest
    >({
      query: ({ name, image, sliceImage, quantityPerPiece, maxLimit }) => {
        return {
          url: API_ENDPOINTS.TOPPING.CREATE,
          method: "POST",
          body: {
            name,
            image,
            sliceImage,
            quantityPerPiece,
            maxLimit,
          },
        };
      },
      invalidatesTags: ["Topping"],
    }),
    // PUT - Update Topping Status
    updateToppingStatus: builder.mutation<
      UpdateToppingStatusResponse,
      UpdateToppingStatusRequest
    >({
      query: ({ id, isActive, restricted }) => ({
        url: API_ENDPOINTS.TOPPING.UPDATE(id),
        method: "PUT",
        body: {
          isActive,
          restricted,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Topping"],
    }),

    // PUT - Update Topping (Full Update)
    updateTopping: builder.mutation<
      UpdateToppingResponse,
      UpdateToppingRequest
    >({
      query: ({ id, name, image, sliceImage, quantityPerPiece, maxLimit }) => ({
        url: API_ENDPOINTS.TOPPING.UPDATE(id),
        method: "PUT",
        body: {
          name,
          image,
          sliceImage,
          quantityPerPiece,
          maxLimit,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Topping"],
    }),

    // DELETE - Delete Topping
    deleteTopping: builder.mutation<
      DeleteToppingResponse,
      DeleteToppingRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.TOPPING.DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["Topping"],
    }),

    // GET - Get Greek Box List
    getGreekBoxList: builder.query<
      GetGreekBoxListResponse,
      GetGreekBoxListRequest
    >({
      query: ({ page = 1, limit = 10, search = "" }) => ({
        url: API_ENDPOINTS.GREEK_BOX.LIST,
        method: "GET",
        params: {
          page,
          limit,
          search,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      providesTags: ["GreekBox"],
    }),

    // DELETE - Delete Greek Box
    deleteGreekBox: builder.mutation<
      DeleteGreekBoxResponse,
      DeleteGreekBoxRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.GREEK_BOX.DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["GreekBox"],
    }),

    // POST - Create Greek Box
    createGreekBox: builder.mutation<
      CreateGreekBoxResponse,
      CreateGreekBoxRequest
    >({
      query: (body) => ({
        url: API_ENDPOINTS.GREEK_BOX.CREATE,
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "admin",
        },
      }),
      invalidatesTags: ["GreekBox"],
    }),

    // PUT - Update Greek Box
    updateGreekBox: builder.mutation<
      UpdateGreekBoxResponse,
      UpdateGreekBoxRequest
    >({
      query: ({ id, ...body }) => ({
        url: API_ENDPOINTS.GREEK_BOX.UPDATE(id),
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["GreekBox"],
    }),

    // GET - Get Yogurt Type List
    getYogurtTypeList: builder.query<
      GetYogurtTypeListResponse,
      GetYogurtTypeListRequest
    >({
      query: ({ page = 1, limit = 10, search = "" }) => ({
        url: API_ENDPOINTS.YOGURT.LIST,
        method: "GET",
        params: {
          page,
          limit,
          search,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      providesTags: ["YogurtType"],
    }),

    // DELETE - Delete Yogurt Type
    deleteYogurtType: builder.mutation<
      DeleteYogurtTypeResponse,
      DeleteYogurtTypeRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.YOGURT.DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // POST - Create Yogurt Type
    createYogurtType: builder.mutation<
      CreateYogurtTypeResponse,
      CreateYogurtTypeRequest
    >({
      query: (body) => ({
        url: API_ENDPOINTS.YOGURT.CREATE,
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // PUT - Update Yogurt Type
    updateYogurtType: builder.mutation<
      UpdateYogurtTypeResponse,
      UpdateYogurtTypeRequest
    >({
      query: ({ id, ...body }) => ({
        url: API_ENDPOINTS.YOGURT.UPDATE(id),
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // PUT - Update Yogurt Type Status
    updateYogurtTypeStatus: builder.mutation<
      UpdateYogurtTypeStatusResponse,
      UpdateYogurtTypeStatusRequest
    >({
      query: ({ id, isActive }) => ({
        url: API_ENDPOINTS.YOGURT.UPDATE(id),
        method: "PUT",
        body: {
          isActive,
        },
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // GET - Get Yogurt Flavor List
    getYogurtFlavorList: builder.query<
      GetYogurtFlavorListResponse,
      GetYogurtFlavorListRequest
    >({
      query: ({ page = 1, limit = 10, search = "", id }) => {
        const params: any = {
          page,
          limit,
          search: search ?? "",
        };
        
        // Always include yogurtId if id is provided and not empty
        if (id && typeof id === 'string' && id.trim() !== "") {
          params.yogurtId = id;
        }
        
        return {
          url: API_ENDPOINTS.YOGURT.FLAVOR_LIST,
          method: "GET",
          params,
          headers: {
            "Content-Type": "application/json",
            "x-portal": "user",
          },
        };
      },
      providesTags: ["YogurtType"],
    }),

    // DELETE - Delete Yogurt Flavor
    deleteYogurtFlavor: builder.mutation<
      DeleteYogurtFlavorResponse,
      DeleteYogurtFlavorRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.YOGURT.FLAVOR_DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // POST - Create Yogurt Flavor
    createYogurtFlavor: builder.mutation<
      CreateYogurtFlavorResponse,
      CreateYogurtFlavorRequest
    >({
      query: (body) => ({
        url: API_ENDPOINTS.YOGURT.FLAVOR_CREATE,
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // PUT - Update Yogurt Flavor
    updateYogurtFlavor: builder.mutation<
      UpdateYogurtFlavorResponse,
      UpdateYogurtFlavorRequest
    >({
      query: ({ id, ...body }) => ({
        url: API_ENDPOINTS.YOGURT.FLAVOR_UPDATE(id),
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // GET - Get Yogurt Topping List
    getYogurtToppingList: builder.query<
      GetYogurtToppingListResponse,
      GetYogurtToppingListRequest
    >({
      query: ({ page = 1, limit = 10, search = "", id }) => {
        const params: any = {
          page,
          limit,
          search: search ?? "",
        };
        
        // Always include yogurtId if id is provided and not empty
        if (id && typeof id === 'string' && id.trim() !== "") {
          params.yogurtId = id;
        }
        
        return {
          url: API_ENDPOINTS.YOGURT.TOPPING_LIST,
          method: "GET",
          params,
          headers: {
            "Content-Type": "application/json",
            "x-portal": "user",
          },
        };
      },
      providesTags: ["YogurtType"],
    }),

    // POST - Create Yogurt Topping
    createYogurtTopping: builder.mutation<
      CreateYogurtToppingResponse,
      CreateYogurtToppingRequest
    >({
      query: (body) => ({
        url: API_ENDPOINTS.YOGURT.TOPPING_CREATE,
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // PUT - Update Yogurt Topping
    updateYogurtTopping: builder.mutation<
      UpdateYogurtToppingResponse,
      UpdateYogurtToppingRequest
    >({
      query: ({ id, ...body }) => ({
        url: API_ENDPOINTS.YOGURT.TOPPING_UPDATE(id),
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),

    // DELETE - Delete Yogurt Topping
    deleteYogurtTopping: builder.mutation<
      DeleteYogurtToppingResponse,
      DeleteYogurtToppingRequest
    >({
      query: ({ id }) => ({
        url: API_ENDPOINTS.YOGURT.TOPPING_DELETE(id),
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-portal": "user",
        },
      }),
      invalidatesTags: ["YogurtType"],
    }),
  }),
});

export const {
  useUploadFileMutation,
  useGetFlavourListQuery,
  useDeleteFlavourMutation,
  useUpdateFlavourStatusMutation,
  useCreateFlavourMutation,
  useUpdateFlavourMutation,
  useGetBoxArtListQuery,
  useDeleteBoxArtMutation,
  useCreateBoxArtMutation,
  useUpdateBoxArtMutation,
  useUpdateBoxArtStatusMutation,
  useGetToppingListQuery,
  useDeleteToppingMutation,
  useCreateToppingMutation,
  useUpdateToppingStatusMutation,
  useUpdateToppingMutation,
  useGetGreekBoxListQuery,
  useDeleteGreekBoxMutation,
  useCreateGreekBoxMutation,
  useUpdateGreekBoxMutation,
  useGetYogurtTypeListQuery,
  useDeleteYogurtTypeMutation,
  useCreateYogurtTypeMutation,
  useUpdateYogurtTypeMutation,
  useUpdateYogurtTypeStatusMutation,
  useGetYogurtFlavorListQuery,
  useDeleteYogurtFlavorMutation,
  useCreateYogurtFlavorMutation,
  useUpdateYogurtFlavorMutation,
  useGetYogurtToppingListQuery,
  useCreateYogurtToppingMutation,
  useUpdateYogurtToppingMutation,
  useDeleteYogurtToppingMutation,
} = commonAPI;
